import { render, staticRenderFns } from "./NavPage.vue?vue&type=template&id=265da942&scoped=true&"
import script from "./NavPage.vue?vue&type=script&lang=js&"
export * from "./NavPage.vue?vue&type=script&lang=js&"
import style0 from "./NavPage.vue?vue&type=style&index=0&id=265da942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265da942",
  null
  
)

export default component.exports